import { usePrefix } from '../usePrefix';
import { ROUTES, ROUTES_INFORMATION } from '~~/constants/routes';
import { getSlugForRoute } from '~~/helpers/routes/getPageInformation';
import { getPrefix, getPrefixedSlug } from '~~/helpers/routes/prefixes';
import { HELP_CENTER_TRANSLATION_KEY } from '~~/constants/faq';
import isExternalUrl from '~~/helpers/isExternalUrl/isExternalUrl';

export const useRouteExtended = () => {

  const i18n = useI18n();
  const route = useRoute();
  const { addPrefixToSlugIfNecessary } = usePrefix();

  const replaceRouteWildCard = (route: string, replacement: string) => {

    return route.replace('*', replacement);
  
  };

  const isCurrentRoute = (slug: Maybe<string>): boolean => {

    const prefix = getPrefix(route.fullPath);

    if (prefix) {

      slug = getPrefixedSlug(slug, prefix);
    
    }

    return slug === route.path;
  
  };

  const buildSearchPageUrl = (category: string): string => {

    return replaceRouteWildCard(getAdjustedSlug(ROUTES.SEARCH_CATEGORY), category);
  
  };

  const getAdjustedSlug = (routePath: string): string => {

    const slug = getSlugForRoute(routePath);
    const slugTranslatedIfNecessary = getTranslatedSlug(slug);
    const slugPrefixedIfNecessary = addPrefixToSlugIfNecessary(slugTranslatedIfNecessary) || slugTranslatedIfNecessary;

    return slugPrefixedIfNecessary;
  
  };

  const getUrlByRouteKey = (routeKey: string): string => {

    const slug = ROUTES_INFORMATION[routeKey]?.SLUG;

    if (!slug) {

      return '';
    
    }

    if (isExternalUrl(slug)) {

      return slug;
    
    }

    if (slug === HELP_CENTER_TRANSLATION_KEY) {

      return i18n.t(slug);
    
    }

    return getAdjustedSlug(routeKey);
  
  };

  const getTranslatedSlug = (slug: string): string => {

    if (i18n?.te(slug)) {

      return i18n?.t(slug);
    
    }

    return slug;
  
  };

  return {
    buildSearchPageUrl,
    isCurrentRoute,
    getAdjustedSlug,
    getUrlByRouteKey,
  };

};
